import { InboxActiveTab, inboxActiveTab } from "./enum";

export interface ToggleVisibility {
  overdue: boolean;
  completed: boolean;
}

export type InboxAccordion = Record<InboxActiveTab, ToggleVisibility>;

export const DEFAULT_INBOX_ACCORDION: InboxAccordion = {
  [inboxActiveTab.INBOX]: { overdue: false, completed: false }, // "inbox"
  [inboxActiveTab.TODAY]: { overdue: false, completed: false }, // "today"
};
